export default {
  flood: "Peligro de inundación",
  landslide: "Procesos de remoción en masa",
  urban: "Presencia de Urbanización",
  water: "Cuerpos de Agua y Cursos Fluviales",
  expansion: "Probabilidad de expansión urbana",
  risk: "Riesgo",
  protected: "Áreas protegidas"
}
